import { cUtil }                    from "../../../functions/util";
import { cSingleProductOrderLists } from "../order-list/single-product-order-lists";
import { cProductItem }             from "../../../components/product-item/product-item";

export class cSingleProduct implements OrderItemContainer {

  fieldset_buttons      = document.createElement('fieldset');
  button_buttonList     = document.createElement('button');
  button_buttonCart     = document.createElement('button');
  div_mwst              = document.createElement('div');
  wcAddToCartButtonElm  = document.querySelector('button[name = "add-to-cart"]')    as HTMLButtonElement;
  wcForm                = document.querySelector('form.cart')                       as HTMLFormElement;
  script                = document.querySelector('.c-single-product.c-item script') as HTMLScriptElement;
  parent                = document.querySelector('.c-single-product.c-item')        as HTMLElement;
  p_price               = document.querySelector('.single-product .price')          as HTMLElement;
  div_main1             = document.querySelector('.single-product .entry-summary')  as HTMLElement;

  productItem: cProductItem | undefined;

  constructor() {
    const { __, _x, _n, sprintf } = wp.i18n as i18n;

    const input = JSON.parse(this.script.textContent) as SingleProduct;

    // ---- Structure ----
  
    this.productItem = new cProductItem(input, this.parent, this, 'single-product');

    this.div_main1.prepend(this.productItem.amounts.div_priceText)
    this.p_price.textContent = '';
    this.p_price.append(this.productItem.amounts.div_price);
      this.productItem.amounts.div_price.append(this.div_mwst);

    this.parent.append(this.fieldset_buttons);
      this.fieldset_buttons.append(this.button_buttonList);
      this.fieldset_buttons.append(this.button_buttonCart);

    const orderList = new cSingleProductOrderLists(
      input.item.customer_id,
      input.lists, 
      input.nonce, 
      this.parent,
      this.productItem,
    );

    // ---- Classes ----
    this.css('fieldset_buttons');
    this.button_buttonCart.classList.add('c-button', 'button_buttonCart');
    this.button_buttonList.classList.add('c-button', 'button_buttonList');

    this.productItem.amounts.fieldset_sellingUnit .style.gridArea = '';
    this.productItem.amounts.fieldset_amount      .style.gridArea = '';
    this.productItem.amounts.div_summaryPiece     .style.gridArea = '';
    this.productItem.marinades.fieldset_marinades .style.gridArea = '';

    // ---- Texts ----
    this.button_buttonList.textContent = __('Zur Bestellliste hinzufügen', 'custom');
    this.button_buttonCart.textContent = __('In den Warenkorb', 'custom');
    this.div_mwst        .textContent = 'exkl. MwSt.';

    // ---- Other ----
    this.button_buttonList.type       = 'button';
    this.button_buttonCart.type       = 'button';

    const pieceText   = this.productItem.amounts.div_summaryPiece.textContent;
    const nettoWeight = this.productItem.amounts.product.amounts.nettoWeight;
    const inputType   = this.productItem.amounts.product.amounts.inputType;
   
    this.productItem.amounts.div_summaryPiece.textContent;

    // ---- Tab Index ---
    const index = 100;
    this.productItem.deliveryDate.date.input      .tabIndex = index + 1;
    this.productItem.amounts.input_amount         .tabIndex = index + 2;
    this.productItem.amounts.select_amountSelect  .tabIndex = index + 3;
    this.productItem.amounts.input_weightPerPiece .tabIndex = index + 4;
    this.productItem.amounts.platter?.setTabIndex(index + 4);
    this.productItem.amounts.select_sellingUnit   .tabIndex = index + 5;
    this.productItem.marinades.select_marinades   .tabIndex = index + 6;
    this.productItem.comment.textarea_comment     .tabIndex = index + 7;
    this.button_buttonList                        .tabIndex = index + 8;
    this.button_buttonCart                        .tabIndex = index + 9;

    // ---- Init ----
    // Price was calculated before the delivery date existed, recalculate for the initial date
    this.productItem.validateItem('silent', '');

    cUtil.gaSaveData([this.productItem], 'view_item', 'single-product', '');
    cUtil.gaSendFromStorage();

    // ---- Events ----
    this.button_buttonList.addEventListener('click', () => {
      orderList.open();
    });

    this.button_buttonCart.addEventListener('click', () => {
      if (this.productItem === undefined) return;
      const isValid = this.productItem.validateItem('', '');
      if(isValid) {
        this.productItem.dataToInputElm();
        this.wcAddToCartButtonElm.click();
        cUtil.gaSaveData([this.productItem], 'add_to_cart', 'single-product', '');
      }
    });

    cUtil.enterToNextField(this.wcForm);
  }

  changeEvent(eventSource: string): void {
    this.productItem?.validateItem('', '');
  }
  setErrorMessage(message: string) {
  }
  deleteItem(itemId: string) {
  }

  css<K extends keyof cSingleProduct>(propertyName: K): void {
    const property = this[propertyName];
    if (! (property instanceof HTMLElement)) return;
    property.classList.add(propertyName);
    property.style.gridArea = propertyName;
  }
}